import "core-js/modules/es.object.freeze";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classnames from 'classnames';
import { textConvertToMultiLine } from "../../../utils";
import styles from './Text.scss';
export var SIZE = Object.freeze({
  small: 'small',
  regular: 'regular',

  /**
   * @deprecated Вместо него нужно использовать H3,
   */
  large: 'large',
  inherit: 'inherit'
});

var Text = function Text(_ref) {
  var _classnames;

  var className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'p' : _ref$tag,
      htmlFor = _ref.htmlFor,
      children = _ref.children,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'left' : _ref$align,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? SIZE.regular : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'text' : _ref$color,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline,
      _ref$paragraph = _ref.paragraph,
      paragraph = _ref$paragraph === void 0 ? false : _ref$paragraph,
      _ref$wrap = _ref.wrap,
      wrap = _ref$wrap === void 0 ? false : _ref$wrap,
      _ref$multiLine = _ref.multiLine,
      multiLine = _ref$multiLine === void 0 ? false : _ref$multiLine;
  var Tag = tag;
  if (inline) Tag = 'span';
  return /*#__PURE__*/React.createElement(Tag, {
    htmlFor: htmlFor,
    className: classnames(styles.text, className, (_classnames = {}, _defineProperty(_classnames, styles["text-paragraph"], paragraph), _defineProperty(_classnames, styles["text-color--".concat(String(color))], color !== 'text'), _defineProperty(_classnames, styles["text-size--".concat(String(size))], size), _defineProperty(_classnames, styles["text-align--".concat(String(align))], align !== 'left'), _defineProperty(_classnames, styles['text-wrap'], wrap), _classnames))
  }, multiLine ? textConvertToMultiLine(children) : children);
};

Text.size = SIZE;
export default Text;